import { render, staticRenderFns } from "./FurnitureSales.vue?vue&type=template&id=05f07e7f&scoped=true&"
import script from "./FurnitureSales.vue?vue&type=script&lang=js&"
export * from "./FurnitureSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f07e7f",
  null
  
)

export default component.exports